export default {
  title: 'Панель управления'
}
